import type { BinaryAnswer } from '@/constants/answers';
import { type InstitutionDetailsV2ComplianceTraining, institutionDetailsV2ComplianceTrainingSchema } from '@/services/api/profile';

export type InstitutionComplianceTraining = {
  trainingBoard?: BinaryAnswer;
  trainingFirstLine?: BinaryAnswer;
  trainingSecondLine?: BinaryAnswer;
  trainingThirdLine?: BinaryAnswer;
  complianceHeadcount?: number;
  abcPolicies?: BinaryAnswer;
  privacyPolicyCompliant?: BinaryAnswer;
};

export type InstitutionComplianceTrainingOrDefaults = InstitutionComplianceTraining | Partial<InstitutionComplianceTraining>;

export const institutionComplianceTrainingToInstitutionDetailsComplianceTrainingApi = (
  complianceTraining: InstitutionComplianceTraining,
): Promise<InstitutionDetailsV2ComplianceTraining> => institutionDetailsV2ComplianceTrainingSchema.parseAsync(complianceTraining);
